@if (send) {
  <h3 i18n>Bestätigen Sie Ihre E-Mail-Adresse</h3>
  <p i18n>
    Wir senden Ihnen eine E-Mail zur Bestätigung Ihrer Preisanfrage. Nachdem Sie die Gültigkeit Ihrer E-Mail-Adresse
    bestätigt haben, wird Ihr Preisvorschlag an den Verkäufer übermittelt.
  </p>

  <a edButton (click)="close()" i18n>
    Verstanden
  </a>
} @else {
  <form (submit)="submit($event)">
    <div class="e-head">
      <h3 i18n>Preis vorschlagen</h3>
      <div class="e-close" (click)="close()">
        &times;
      </div>
    </div>

    <p i18n>
      Machen Sie dem Inhaber der Domain einen lukrativen Preisvorschlag. Er kann sich dann mit einem verbindlichen Angebot bei Ihnen melden.
    </p>

    <label>
      <span class="ed-label" i18n>E-Mail-Adresse <sup>*</sup></span>
      <input [formControl]="control('email')" type="text">

      @if (touched && control('email').invalid) {
        <span class="e-error">
           @if (control('email').value) {
             <ng-container i18n>Bitte gebe eine valide E-Mail-Adresse ein</ng-container>
           } @else {
             <ng-container i18n>Dieses Feld muss ausgefüllt sein</ng-container>
           }
        </span>
      }
    </label>

    <div class="ed-offer-price">
      <div class="ed-offer-name">
        {{ data.context.config.name }}
      </div>

      @if (data.context.config.price) {
        <div class="grid">
          <div class="cell s6">
            <ng-container *ngTemplateOutlet="priceInputTmpl"/>
          </div>
          <div class="cell s6 ed-og-price">
            <div class="ed-og-price-label" i18n>Originalpreis</div>
            <div class="ed-og-price-amount">{{ data.context.config.price | currency : '' : '' : '1.0-0' }} €</div>
          </div>
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="priceInputTmpl"/>
      }

      @if (touched && control('price').invalid) {
        <span class="e-error">
          @if (control('price').errors?.['min']) {
            <ng-container i18n>Der Vorschlag muss mindestens 99 € betragen</ng-container>
          } @else if (control('price').errors?.['required']) {
            <ng-container i18n>Dieses Feld muss ausgefüllt sein</ng-container>
          } @else if (control('price').errors?.['max']) {
            <ng-container i18n>Der Preisvorschlag muss min. 10 € günstiger als der Originalpreis sein</ng-container>
          } @else if (control('price').errors?.['offer_price']) {
            <ng-container i18n>Der Preisvorschlag darf nicht geringer als 25% des Originalpreis sein</ng-container>
          }
        </span>
      }
    </div>

    <p class="ed-legal" i18n>
      Indem Sie fortfahren, erklären Sie sich mit unseren
      <a [href]="data.context.links.terms|userToken">Allgemeinen Geschäftsbedingungen</a> und unserer <a [href]="data.context.links.privacy">Datenschutzrichtlinie</a>
      einverstanden.
    </p>

    <div class="ed-actions">
      <div (click)="cancel($event)" [edButton]="{ theme: 'light' }" i18n>
        Abbrechen
      </div>
      <button type="submit" [edButton]="{ loading: sending, disabled: form.invalid }" i18n>
        Absenden
      </button>
    </div>
  </form>
}

<ng-template #priceInputTmpl>
  <label>
    <span class="ed-label" i18n>Preisvorschlag <sup>*</sup></span>

    <span class="e-currency-input-frame">
      <input type="number" [formControl]="control('price')" min="0" step="1">
    </span>

  </label>
</ng-template>

<ng-template #priceInputTmpl>
  <label>
    <span class="ed-label" i18n>Preisvorschlag <sup>*</sup></span>
    <input [formControl]="control('price')" type="number" min="0" step="1">
  </label>
</ng-template>
